var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.32041 0C3.82173 0 0.174805 3.42628 0.174805 7.65278C0.174805 17.1528 13.6572 19 13.6572 19V15.3056H14.4998C18.9985 15.3056 22.6454 11.8793 22.6454 7.65278C22.6454 3.42628 18.9985 0 14.4998 0H8.32041ZM11.4101 9.23611C12.1858 9.23611 12.8145 8.64537 12.8145 7.91667C12.8145 7.18796 12.1858 6.59722 11.4101 6.59722C10.6345 6.59722 10.0057 7.18796 10.0057 7.91667C10.0057 8.64537 10.6345 9.23611 11.4101 9.23611ZM17.3087 7.91667C17.3087 8.64537 16.6799 9.23611 15.9042 9.23611C15.1286 9.23611 14.4998 8.64537 14.4998 7.91667C14.4998 7.18796 15.1286 6.59722 15.9042 6.59722C16.6799 6.59722 17.3087 7.18796 17.3087 7.91667ZM6.91599 9.23611C7.69162 9.23611 8.32041 8.64537 8.32041 7.91667C8.32041 7.18796 7.69162 6.59722 6.91599 6.59722C6.14036 6.59722 5.51158 7.18796 5.51158 7.91667C5.51158 8.64537 6.14036 9.23611 6.91599 9.23611Z",
    fill: "#5A7D65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment3);
export default __webpack_public_path__ + "static/media/payment_3.8439e09a0e0e02c9ba5e6e415daf61ae.svg";
export { ForwardRef as ReactComponent };